import { Component, OnInit } from '@angular/core';
import {MobileMenuService} from '../../../mobile/mobile-menu/mobile-menu.service';
import {TranslateService} from '@ngx-translate/core';
import {UserModel} from '../../../models/authentication/user.model';
import {StudentModel} from '../../../models/authentication/student.model';
import {ChargebeeService} from '../../../services/student/chargebee.service';
import {Router} from '@angular/router';
import {SchoolModel} from '../../../models/school/school.model';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-platform-root',
  templateUrl: './platform-root.component.html',
  styleUrls: ['./platform-root.component.css']
})
export class PlatformRootComponent implements OnInit {

  ChargebeeBillingStatuses = StudentModel.ChargebeeSubscriptionsStatusTypes;
  cbInstance: any;

  constructor(public mobileMenuSv: MobileMenuService,
              private cbSv: ChargebeeService,
              private router: Router,
              private tSv: TranslateService) { }

  ngOnInit() {

    if (window['Chargebee']) {
      this.cbInstance = window['Chargebee'].getInstance();
    }

    if (UserModel.getCurrent()) {
      if (this.tSv.currentLang !== UserModel.getCurrent().culture) {
        this.tSv.use(UserModel.getCurrent().culture);
      }
    }

  }

  isConsumer() {

    if (StudentModel.getCurrent() && StudentModel.getCurrent().schoolAccess.length === 0) {

      return true;
    }

    return false;

  }

  isPaymentNeeded() {

    if (this.isConsumer()) {

      const billingStatus = StudentModel.getCurrent().billingStatus;

      if ((billingStatus !== this.ChargebeeBillingStatuses.active &&
        billingStatus !== this.ChargebeeBillingStatuses.inTrial &&
        billingStatus !== this.ChargebeeBillingStatuses.nonRenewing) &&
        (StudentModel.getCurrent().isBillingCancelled() === true || StudentModel.getCurrent().isBillingNotStarted()) ) {
        return true;
      }

    }

    return false;
  }

  getPaymentTitle() {

    if (StudentModel.getCurrent().schoolAccess && StudentModel.getCurrent().schoolAccess.length > 0) {

      if (StudentModel.getCurrent().isBillingCancelled()) {
        return this.tSv.instant('selectStudent.licenseExpired');
      }

    } else {

      const billingStatus = StudentModel.getCurrent().billingStatus;
      if (billingStatus === this.ChargebeeBillingStatuses.cancelled) {
        return this.tSv.instant('dashboard.paymentError.cancelled');
      } else if (StudentModel.getCurrent().isTrialExpired()) {
        return this.tSv.instant('dashboard.paymentError.trialExpired');
      }

    }

    return this.tSv.instant('dashboard.paymentError.notSubscribed');
  }

  getPaymentButtonTitle()  {

    if (StudentModel.getCurrent().schoolId) {
      return this.tSv.instant('lp2.footer.contactUs');
    }

    const billingStatus = StudentModel.getCurrent().billingStatus;
    if (billingStatus === this.ChargebeeBillingStatuses.cancelled) {
      return this.tSv.instant('reusable.renewNow');
    }

    return this.tSv.instant('reusable.buyNow');
  }

  onPaymentButtonClicked() {

    if (StudentModel.getCurrent().schoolId) {
      return this.router.navigate(NavigationModel.getHomeURLPaths(['contactUs']));
    }

    const billingStatus = StudentModel.getCurrent().billingStatus;
    if (billingStatus === this.ChargebeeBillingStatuses.cancelled) {

      // Implementation for portal sessions: https://www.chargebee.com/checkout-portal-docs/api-portal.html#integration-steps
      this.cbInstance.setPortalSession(() => {
        return this.cbSv.manageSubscriptionCheckout();
      });


      const cbPortal = this.cbInstance.createChargebeePortal();
      cbPortal.open({
        close: () => {
          // close callbacks
          // Update the student status if the user has changed their subscription.
          this.cbSv.updateStudentSubscriptionStatus().subscribe((student) => {
            StudentModel.setCurrent(student);
          });
        }
      });

    } else {

      this.router.navigate(['selectsub']);

    }



  }

  getRouterHeight() {

    if (this.isPaymentNeeded()) {
      return 'calc(100% - 70px)';
    }

    return '100%';
  }

}
